import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import CustomerApp from './CustomerApp';
import './index.css';
import { Toaster } from 'react-hot-toast';
import { CartProvider } from './contexts/CartContext';
import { getToasterProps } from './toasterConfig';

const root = ReactDOM.createRoot(document.getElementById('root'));
const appVariant = process.env.REACT_APP_APP_VARIANT || 'staff';
const RootApp = appVariant === 'customer' ? CustomerApp : App;
root.render(
  <React.StrictMode>
    <CartProvider>
      <RootApp />
      <Toaster {...getToasterProps(appVariant)} />
    </CartProvider>
  </React.StrictMode>
);

if ('serviceWorker' in navigator) {
  window.addEventListener('load', () => {
    navigator.serviceWorker
      .register('/sw.js')
      .then((registration) => {
        console.log('Service worker registered with scope:', registration.scope);
      })
      .catch((err) => {
        console.warn('Service worker registration failed:', err);
      });
  });
}
